﻿import { PriceList } from "./PriceList";
import { Product } from "./Product";
import { PriceDiscount } from "./PriceDiscount";
import { Currency, RoundingPolicy } from "../Currency";

export enum PriceType {
    Amount = 0,
    Percent = 1,
}

export class Price implements IPrice {
    constructor(price?: IPrice, priceList?: PriceList) {
        // initialize typed object from generic object
        this._priceList = priceList;
        this.productNumber = price?.productNumber ?? "";
        this.unitCode = price?.unitCode ?? "";
        this.priceType = price?.priceType ?? PriceType.Amount;
        this.roundingPolicy = price?.roundingPolicy ?? RoundingPolicy.RoundUp;
        this.amountOrPercent = price?.amountOrPercent ?? 0;
        this.discountCode = price?.discountCode;
    }

    toJSON(): object {
        // return generic object with properties to stringify
        return {
            productNumber: this.productNumber,
            unitCode: this.unitCode,
            priceType: this.priceType,
            roundingPolicy: this.roundingPolicy,
            amountOrPercent: this.amountOrPercent,
            discountCode: this.discountCode
        };
    }

    productNumber: string;
    unitCode: string;
    priceType: PriceType;
    roundingPolicy: RoundingPolicy;
    amountOrPercent: number;
    discountCode?: string;

    private _priceList?: PriceList;

    // Calculated properties

    get product(): Product | undefined {
        return this._priceList?.products?.find(product => product.productNumber === this.productNumber);
    }

    get discount(): PriceDiscount | undefined {
        return this._priceList?.discounts?.find(discount => discount.discountCode === this.discountCode);
    }

    get unitPrice(): number {
        return Currency.round(
            this.amountOrPercent *
            (this.priceType === PriceType.Percent
                ? Currency.exchange(this.product?.listPrice ?? 0, this.product?.currencyCode ?? "USD", this.currencyCode)
                : 1),
            this.currencyCode,
            this.roundingPolicy);
    }

    get currencyCode(): string {
        return this._priceList?.currencyCode ?? "USD";
    }
}

export interface IPrice {
    productNumber: string;
    unitCode: string;
    priceType: PriceType;
    roundingPolicy: RoundingPolicy;
    amountOrPercent: number;
    discountCode?: string;
}